import { useContext } from "react";
import { MyContext } from "./MyContextProvider";
import { BaseEdge, getSmoothStepPath } from "@xyflow/react";
import { EdgeProps } from "@xyflow/react";

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  selected,
  sourcePosition,
  targetPosition,
  markerEnd,
}: EdgeProps) {
  const { data } = useContext(MyContext);

  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: selected ? "#ef4444" : data[id]?.selected ? "#f97316" : "#9ca3af",
          strokeWidth: 1.5,
        }}
        markerEnd={markerEnd}
      />
    </>
  );
}
